<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="450"
      :loading="loading"
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
      cell-class-name="align-top"
      :footer-method="() => footerData"
      show-footer
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="text">
              {{ $l('table_product_details_list') || '产品明细列表' }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:imageUrl="{ row }">
        <el-image
          class="viewImage"
          :preview-src-list="[row.imageUrl]"
          :src="
            row.thumbImageUrl
              ? $osscdn(row.thumbImageUrl)
              : '/image/static/img/nopic.jpg'
          "
        />
      </template>
      <template v-slot:fabric="{ row }">
        <span>{{ row.fabricNo || '' }}</span>
        <br />
        <span>{{ row.fabricName || '' }}</span>
        <br />
        <span>成分：{{ row.fabricContent || '' }}</span>
      </template>
      <template v-slot:fabricWidWeight="{ row }">
        <span
          >克重：{{ row.fabricWeight || '' }}
          {{ row.fabricWeightUnit || '' }}</span
        >
        <br />
        <span>门幅：{{ row.fabricWid || '' }} {{ row.widUnit || '' }}</span>
      </template>

      <template v-slot:color="{ row }">
        <span>颜色：{{ row.colorName || '' }}</span>
        <br />
        <span>编号：{{ row.ftyColorNo || '' }}</span>
      </template>
      <template v-slot:demandPerson="{ row }">
        <span>{{ row.demandPersonName || '' }}</span>
        <br />
        <span>{{ row.demandDate || '' }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, divideRound, multiplyRound, format } from '@/libs/util.number.js'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    resFabricPurchaseCode: { type: String, default: '' },
    depCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.loadData(),
        },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableData: [],
      delCodeList: [],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    validRules() {
      return {
        subAmount: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: '小计金额须大于0',
          },
        ],
        purchaseQty: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: '采购数量须大于0',
          },
        ],
      }
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[3] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  watch: {},
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.resFabricPurchaseCode) return
      this.loading = true
      this.$api
        .resFabricPurchaseDetailListApi({
          resFabricPurchaseCode: this.resFabricPurchaseCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.updateTotAmount()
        })
        .catch(() => {
          this.loading = false
        })
    },

    async delRow(row) {
      this.delCodeList.push(row.resFabricDemandDetailCode)
      this.$refs.itemTable.remove(row)
      let index = this.$refs.itemTable.getRowIndex(row)
      this.tableData.splice(index, 1)
      this.updateTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    getDelCodeList() {
      return this.delCodeList
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async subTotAmount({ column = {}, row = {} }) {
      if (column) {
        const { property } = column
        if (property == 'subAmount') {
          row.unitPrice = divideRound(row.subAmount, row.purchaseQty, 2)
        }
        if (property == 'purchaseQty') {
          row.subAmount = multiplyRound(row.unitPrice, row.purchaseQty, 2)
        }
        if (property == 'unitPrice') {
          row.subAmount = multiplyRound(row.unitPrice, row.purchaseQty, 2)
        }
      }
      this.updateTotAmount()
    },
    updateTotAmount() {
      const surchargeAmount = this.tableData.reduce(
        (result, next) => add(result, next.surchargeAmount),
        0
      )
      const fabricAmount = this.tableData.reduce(
        (result, next) => add(result, next.subAmount),
        0
      )
      const totalAmount = add(surchargeAmount, fabricAmount)
      this.$refs.itemTable.updateFooter()
      this.$emit('updateTotAmount', {surchargeAmount, fabricAmount, totalAmount})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
}
.text {
  color: #6c6c6c;
  font-size: 14px;
}
</style>
